/* Tabs switcher */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var button = e.target.closest('.tab-button');
    if (!button) return;

    var container = button.closest('.tabs-container');
    if (!container) return;

    var tabId = button.getAttribute('data-tab');

    container.querySelectorAll('.tab-button').forEach(function(btn){
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });

    container.querySelectorAll('.tab-panel').forEach(function(panel){
      panel.classList.remove('active');
      panel.setAttribute('hidden', '');
    });

    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');

    var activePanel = container.querySelector('#tab-' + tabId);
    if (activePanel) {
      activePanel.classList.add('active');
      activePanel.removeAttribute('hidden');
    }
  });
})();
